import {Toast} from "vant";
import store from '../store'
import { websocketPath } from '@/config/project-config'
export default class websocketService {
  static instance = null
  static get Instance () {
    if (!this.instance) {
      this.instance = new websocketService()
    }
    return this.instance
  }
  socket = null
  heart = false
  socketTimer = null
  path = websocketPath
  nowSocketId = ''
  init () {
    if(typeof(WebSocket) === "undefined"){
      Toast("浏览器不支持websocket")
      return
    }
    if (this.socket != null) {
      return
    }
    this.socket = new WebSocket(this.path + this.nowSocketId)
    this.socket.onopen = () => {
      this.heart = true;
      this.heartJump();
      console.log("websocket连接成功")
      this.connTime = 0
    }
    this.socket.onerror = () => {
      this.heart = false
      console.log("关闭websocket连接错误")
    }
    this.socket.onmessage = (msg) => {
      if (msg.data != '$_#') {
        store.commit('webSocketMsg', msg)
      } else {
        console.log("心跳消息")
      }
    }
    this.socket.onclose = () => {
      const _this = this
      _this.heart = false;
      if (this.socket != null) {
        setTimeout(function () {
          console.log("正在尝试连接websocket")
          _this.socket = null;
          _this.init(null)
        }, 3*1000);
      }
    }
  }
  sendMessage (msg) {
    this.socket.send(msg)
  }

  heartJump (){
    const _this = this
    this.socketTimer = setInterval(() => {
      if (_this.heart){
        _this.sendMessage("$_#")
        console.log("检测心跳")
      }
    }, 60*4*1000+30000)
  }

  clear () {
    clearInterval(this.socketTimer)
    if(this.socket != null) {
      this.socket.close()
      this.socket = null
    }
    this.heart = false
    this.nowSocketId = null
    this.socketTimer = null
  }

}



// WEBPACK FOOTER //
// ./src/common/websocket.js